module.exports = __webpack_public_path__ + "img/home-bg.56fd3de8.jpg";